import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import axios from 'helpers/axioshelper';
import config from '../config';
import moment from 'moment';
import { withContext } from '../helpers/context';

class NotificationHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalCount: 0,
      notifList: [],
      userAccount: props.name
    };

    this.loadData();
  }

  async loadData() {
    axios({
      method: 'post',
      url: config.urlEndPointDev + 'api/Notification/HeaderNotifications',
      responseType: 'json'
      // data: {
      //     "userAccount": this.state.userAccount
      // }
    })
      .then((response) => {
        // console.log(this.state.userAccount,"notificationya",response.data)
        this.setState({
          notifList: response.data.items,
          totalCount: response.data.totalCount
        });
      })
      .catch((error) => {
        console.log('contextApi error.response', error.response);
      });
  }

  render() {
    var notifList = this.state.notifList.map(function (item) {
      return (
        <span>
          <li>
            <a className="dropdown-item" onClick={() => (window.location.href = item.targetUrl)}>
              <div>
                <p>{item.message}</p>
                <span className="float-right text-muted small">
                  <i className="fa fa-clock-o"></i> {item.notificationRelativeTime}
                </span>
              </div>
            </a>
          </li>
          <li className="dropdown-divider"></li>
        </span>
      );
    }, this);
    return (
      <>
        <li className="dropdown">
          <a className="dropdown-toggle count-info" data-toggle="dropdown" href="#">
            <i className="fa fa-bell" />{' '}
            <span className="label label-primary">{this.state.totalCount}</span>
          </a>
          <ul className="dropdown-menu dropdown-alerts">
            {notifList}
            <li>
              <button
                onClick={() => this.props.history.push(`/features/notification`)}
                className="dropdown-item dropdown-alerts-see-more"
              >
                see more
              </button>
            </li>
          </ul>
        </li>
      </>
    );
  }
}

export default withRouter(withContext(NotificationHeader));
